// extracted by mini-css-extract-plugin
export default {"brandOneSection":"BrandOne_brandOneSection__pw9JR","brandImage":"BrandOne_brandImage__yIpEX","slider":"BrandOne_slider__n8KaP"};